export default __webpack_public_path__ + "static/media/GooglePlayGet.1900e2a3.png";